import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.fixed.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import AzRating from '~/components/_next/atoms/AzRating.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { SCHEMA_REVIEW, SCHEMA_PERSON, SCHEMA_RATING } from '~/constants';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CardRatingsAndReviewsGraphql',
  props: {
    rating: {
      type: Number,
      default: 0
    },
    customerServiceResponses: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    urlImg: {
      type: String,
      default: ''
    },
    productName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    picture: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    productLink: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var _props$customerServic, _props$customerServic2, _props$customerServic3, _props$customerServic4, _props$customerServic5, _props$customerServic6;
    var props = __props;
    var AzExpandableText = function AzExpandableText() {
      return import('~/components/_next/molecules/AzExpandableText.vue');
    };
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var customerServiceResponseStandardise = reactive({
      date: (props === null || props === void 0 ? void 0 : (_props$customerServic = props.customerServiceResponses) === null || _props$customerServic === void 0 ? void 0 : (_props$customerServic2 = _props$customerServic[0]) === null || _props$customerServic2 === void 0 ? void 0 : _props$customerServic2.date) || (props === null || props === void 0 ? void 0 : (_props$customerServic3 = props.customerServiceResponses) === null || _props$customerServic3 === void 0 ? void 0 : (_props$customerServic4 = _props$customerServic3[0]) === null || _props$customerServic4 === void 0 ? void 0 : _props$customerServic4.comment_date),
      comment: props === null || props === void 0 ? void 0 : (_props$customerServic5 = props.customerServiceResponses) === null || _props$customerServic5 === void 0 ? void 0 : (_props$customerServic6 = _props$customerServic5[0]) === null || _props$customerServic6 === void 0 ? void 0 : _props$customerServic6.comment
    });
    var isOldCustomerService = computed(function () {
      return props.description === 'Texte Invisible';
    });

    /**
     * Gets a random color.
     *
     * @return     {string}  The random color.
     */
    function getRandomColor() {
      var arrayColors = ['#FFF7E0', '#FBEDEC', '#FFEDDD', '#F2EDFF'];
      var color = arrayColors[Math.floor(Math.random() * 3)];
      return color;
    }

    /**
     * Capitalizes the given word
     *
     * @param      {string}  word    The word
     * @return     {string}  The capitalized word
     */
    function capitalize(word) {
      if (!word) return;
      return word[0].toUpperCase() + word.slice(0, 0);
    }

    /**
     * Removes microseconds.
     *
     * @param      {string}  dateStr  The date string
     * @return     {string}  The date string without microseconds
     */
    function removeMicroseconds(dateStr) {
      return dateStr && dateStr.split('.')[0];
    }

    /**
     * Gets the date ago.
     *
     * @param      {string}  dateString  The date string
     * @return     {string}  The date ago.
     */
    function getDateAgo(dateString) {
      var cleanedDateString = removeMicroseconds(dateString);
      var date = new Date(cleanedDateString);
      var today = new Date();
      var diff = date > today ? new Date(date - today) : new Date(today - date);
      var diffInDays = Math.floor(diff / (1000 * 60 * 60 * 24));
      var times = [{
        limit: 0,
        key: 'today'
      }, {
        limit: 1,
        key: 'day'
      }, {
        limit: 30,
        key: 'days',
        factor: 1
      }, {
        limit: 365,
        key: 'month',
        factor: 30
      }, {
        limit: 730,
        key: 'year',
        factor: 365,
        fixed: 1
      }, {
        limit: Infinity,
        key: 'years',
        factor: 365
      }];
      for (var _i = 0, _times = times; _i < _times.length; _i++) {
        var time = _times[_i];
        if (diffInDays < time.limit) {
          var name = time.fixed || Math.floor(diffInDays / time.factor);
          return translate("ratingReviews.".concat(time.key)).replace('{name}', name);
        }
      }
    }

    /**
     * Gets the first name.
     *
     * @param      {string}  fullName  The full name
     * @return     {string}  The first name.
     */
    function getFirstName(fullName) {
      var splitName = fullName.split(' ');
      var firstName = splitName[0];
      var firstNameWithFirstLetterUpperCase = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
      return firstNameWithFirstLetterUpperCase;
    }

    /**
     * Returns the proper name
     *
     * @param      {string}  name    The name
     * @return     {string}  The proper name.
     */
    function getProperName(name) {
      if (name === 'anonymous') {
        return capitalize(name);
      } else {
        return getFirstName(name);
      }
    }
    return {
      __sfc: true,
      props: props,
      AzExpandableText: AzExpandableText,
      translate: translate,
      customerServiceResponseStandardise: customerServiceResponseStandardise,
      isOldCustomerService: isOldCustomerService,
      getRandomColor: getRandomColor,
      capitalize: capitalize,
      removeMicroseconds: removeMicroseconds,
      getDateAgo: getDateAgo,
      getFirstName: getFirstName,
      getProperName: getProperName,
      AzRating: AzRating,
      AzImg: AzImg,
      SCHEMA_REVIEW: SCHEMA_REVIEW,
      SCHEMA_PERSON: SCHEMA_PERSON,
      SCHEMA_RATING: SCHEMA_RATING,
      NuxtLinkCustom: NuxtLinkCustom,
      AzIcon: AzIcon
    };
  }
});